/**
 * `crypto.randomUUID()` n'existe que dans un contexte sécurisé (HTTPS, ou `http://localhost`) —
 * absent sinon (ex. floor plan embarqué chez un visiteur final servi en HTTP simple sur un nom
 * d'hôte/IP, voir CLAUDE.md "Dev-only test seam" / BESOINS.md §4 sur le mode visualisation seule).
 * Repli sur `crypto.getRandomValues` (disponible plus largement) puis, en dernier recours, sur
 * `Math.random()`.
 */
export function generateId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6]! & 0x0f) | 0x40;
    bytes[8] = (bytes[8]! & 0x3f) | 0x80;
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }

  return `${Date.now().toString(16)}-${Math.random().toString(16).slice(2)}`;
}
